<script>
import TemplateCategories from './component/TemplateCategories.vue';
import EditTemplate from './component/EditTemplate.vue';
import FooterBar from './component/FooterBar.vue';

export default {
  name: "CreateTemplate",
  components: {
    TemplateCategories,
    EditTemplate,
    FooterBar
  },
  data(){
    return{
      stages: [
        { name: "Set Up Template", value: "setUpTemplate" },
        { name: "Edit Template", value: "editTemplate" },
        { name: "Submit for Review", value: "submitForReview" }
      ],
      currentStage: "setUpTemplate"
    }
  },
  methods: {
    handleNext(){
      if (this.currentStage == 'setUpTemplate'){
        this.currentStage = 'editTemplate';
      }else if(this.currentStage == 'editTemplate'){
        return;
      }
    }
  }
}
</script>

<template>
  <div class="p-4 md:p-8 flex flex-1 h-full flex-col m-0 overflow-auto bg-slate-50 dark:bg-slate-900 transition-colors duration-200">
    <header class="mb-6">
      <div class="flex items-center mb-2">
        <button
          @click="$router.back()"
          class="mr-2 p-2 rounded-full hover:bg-slate-200 dark:hover:bg-slate-800 transition-colors duration-150 flex items-center justify-center"
        >
          <fluent-icon icon="chevron-left" class="h-5 w-5 text-slate-700 dark:text-slate-300" />
        </button>
        <h1 class="text-2xl font-medium text-slate-900 dark:text-slate-100 transition-colors">WhatsApp Template > Create Template</h1>
      </div>
    </header>

    <div class="flex mb-4 justify-between">
      <div class="flex">
        <button 
          v-for="(stage, index) in stages" 
          :key="index" 
          @click="currentStage.value = stage.value; currentStage.index = index"
          :class="{ 'bg-woot-100 text-woot-500': currentStage.value == stage.value, 'hover:bg-slate-400': '' }"
        >
          <fluent-icon v-if="currentStage.index > index" icon="checkmark-circle" size="12" />
          <span v-else class="w-12 h-12 rounded-full bg-woot-500 inline-block"></span>

          {{ stage.name }}</button>
      </div>
      <div class="flex gap-4">
        <woot-button icon="chevron-left">Previous</woot-button>
        <woot-button icon="chevron-right">Next</woot-button>
      </div>
    </div>
    <TemplateCategories v-if="currentStage == 'setUpTemplate'" />
    <EditTemplate v-if="currentStage == 'editTemplate'" />
    <FooterBar @next="handleNext"/>
  </div>
</template>